import React from 'react';

import '../css/about.css';
import fb from '../images/fb_logo.png'
import ig from '../images/Instagram_icon.png'

const About = () => {
  return <div className={"About"}>
    <a href={'https://www.facebook.com/ChadEdwardslive'} target='_'><img className='fb' src={fb} alt='Chad Edwards Band Facebook' /></a>
    <a href={'https://www.instagram.com/chadedwardsband/'} target='_'><img className='fb' src={ig} alt='Chad Edwards Band Instagram' /></a>
    <div className={'summary'}>
      <section class="band-bios">
        <header>
          <h1>The Chad Edwards Band</h1>
          <h2>The Individual Legends</h2>
        </header>

        <article class="band-member">
          <h2>Chad Edwards</h2>
          <p><strong>Acoustic Guitar • Lead Vocals • Founder • Visionary • Possibly the First Edwards</strong></p>

          <p>
            Chad Edwards has spent his adult life quietly accumulating accomplishments
            that would be difficult to fit into a normal biography.
          </p>

          <p>
            A songwriter, guitarist, vocalist, entrepreneur, amateur historian, and
            occasional agricultural consultant, Chad is believed to have written his
            first song before he fully understood what a song was. The composition,
            according to family accounts, consisted of three chords, a sustained note,
            and what has since been identified as an unusually sophisticated bridge.
          </p>

          <p>
            His acoustic guitar technique developed through years of experimentation.
            At one point, Chad reportedly spent an entire winter playing the same chord
            progression until he discovered a previously undocumented harmonic
            relationship between G, C, and “whatever sounds good right there.”
          </p>

          <p>That discovery has never been formally published.</p>

          <p>
            Chad has allegedly performed in more than a dozen states, although the
            exact number depends on whether Wisconsin is counted as one state or “most
            of a state.” His playing has been heard in venues ranging from legitimate
            concert stages to establishments where the stage technically consisted of
            a piece of plywood placed near the bathrooms.
          </p>

          <p>
            He is rumored to have once been offered a recording contract by a Nashville
            executive who subsequently disappeared from the music business. Whether
            these events are connected remains unclear.
          </p>

          <h3>Other Accomplishments</h3>

          <p>
            Chad's non-musical achievements are considerably harder to explain.
          </p>

          <p>
            He once completed a 72-hour period during which he repaired a household
            appliance, negotiated a business transaction, wrote a song, changed a tire,
            and smoked an entire brisket without once consulting written instructions.
          </p>

          <p>
            He has reportedly been asked for advice by people in at least four separate
            professions, including one profession that Chad did not understand.
          </p>

          <p>
            Chad also holds what several sources describe as an “unofficial regional
            record” for identifying songs from the first three seconds of their opening
            guitar riff.
          </p>

          <p>
            In an unrelated achievement, he once correctly predicted that a particular
            parking lot would become extremely crowded approximately four hours before
            it did.
          </p>

          <p>
            He is also said to have developed an innovative method for determining
            whether a beer is sufficiently cold by placing it against his forearm.
          </p>

          <p>The method has never been independently replicated.</p>

          <p>
            Perhaps most impressive, Chad once spent an entire summer attempting to
            learn the complete history of American country music and emerged with the
            firm conviction that most of it could be explained by Hank Williams, bad
            decisions, and the Telecaster.
          </p>

          <p>He has never publicly withdrawn that statement.</p>
        </article>

        <article class="band-member">
          <h2>Mikey Edwards</h2>
          <p><strong>Bass • Vocals • Low-Frequency Specialist • Strategic Advisor</strong></p>

          <p>
            Mikey Edwards is a musician whose accomplishments are routinely
            underestimated because many of them cannot be heard.
          </p>

          <p>
            As bassist for the Chad Edwards Band, Mikey is responsible for maintaining
            the structural integrity of the music. Experts have compared his role to
            “the foundation of a house,” although nobody has established whether this
            is because of his musicianship or because he refuses to move his amplifier.
          </p>

          <p>
            Mikey reportedly learned to play bass by listening to records at a volume
            sufficiently high to alter the molecular structure of the room.
          </p>

          <p>
            His natural sense of rhythm became apparent early. According to family
            lore, Mikey once correctly predicted the exact moment a washing machine
            would enter its spin cycle and subsequently incorporated the rhythm into a
            song.
          </p>

          <p>The song remains unreleased.</p>

          <h3>The Mikey Edwards Record</h3>

          <p>
            Mikey is believed to hold the unofficial record for the longest continuous
            bass line performed while simultaneously carrying on a completely unrelated
            conversation.
          </p>

          <p>
            Witnesses claim he maintained the groove for approximately 47 minutes while
            discussing lawn equipment.
          </p>

          <p>A second account puts the duration closer to 18 minutes.</p>

          <p>Both accounts agree that the lawn equipment discussion was extensive.</p>

          <p>
            Mikey has also allegedly performed bass parts on instruments belonging to
            other musicians without being told what song was being played. In one
            particularly questionable incident, he supposedly walked into a rehearsal,
            picked up an unfamiliar bass, and correctly played the root notes to a song
            that had not yet been written.
          </p>

          <h3>Beyond Music</h3>

          <p>
            Mikey's accomplishments outside music include an extensive and largely
            undocumented career in practical problem solving.
          </p>

          <p>
            He is rumored to have repaired a malfunctioning piece of machinery using
            only a screwdriver, electrical tape, and “a thing he found in the garage.”
          </p>

          <p>
            He has also allegedly navigated a large parking lot without GPS, compass,
            or visible landmarks while simultaneously explaining to three other people
            why they were going the wrong way.
          </p>

          <p>
            Mikey is said to possess an unusually sophisticated understanding of
            weather patterns, automotive noises, and the precise amount of time it takes
            for food to become “probably fine.”
          </p>

          <p>
            He has reportedly never lost an argument about whether a mechanical problem
            is “actually a problem.”
          </p>

          <p>The argument itself may have occurred only once.</p>

          <p>That has not been established.</p>
        </article>

        <article class="band-member">
          <h2>Seamus “James” Edwards</h2>
          <p><strong>Drums • Vocals • Percussion • Temporal Authority</strong></p>

          <p>
            Seamus “James” Edwards is a drummer whose relationship with time is best
            described as adversarial.
          </p>

          <p>
            James reportedly began drumming after discovering that nearly every
            household object could be used as percussion. Pots, pans, boxes, furniture,
            and at least one item whose original purpose remains unknown all allegedly
            contributed to his early development.
          </p>

          <p>
            By adolescence, James had developed a reputation for being able to
            reproduce complicated rhythms after hearing them only once.
          </p>

          <p>
            He later expanded this ability into what some witnesses call “anticipatory
            drumming”—the apparent ability to play the rhythm before knowing what song
            is about to begin.
          </p>

          <p>
            This phenomenon has never been scientifically investigated, largely because
            nobody has been willing to sit through the explanation.
          </p>

          <h3>Competitive Career</h3>

          <p>
            James is rumored to have participated in a drumming competition in which he
            was disqualified for exceeding the maximum allowable enthusiasm.
          </p>

          <p>The official rules reportedly contained no such provision.</p>

          <p>The rules were subsequently amended.</p>

          <p>
            He has also allegedly played a complete song on a drum kit with one missing
            cymbal, one broken stand, and a bass pedal that “wasn't really attached.”
          </p>

          <p>
            His performance was described by one attendee as “the best thing I've ever
            seen and also slightly frightening.”
          </p>

          <h3>Other Achievements</h3>

          <p>
            James has demonstrated unusual competence in fields unrelated to music.
          </p>

          <p>
            He is reputed to have assembled furniture without looking at the
            instructions, correctly predicted the outcome of several sporting events
            based solely on “how the teams looked,” and once found an object that four
            other people had spent an afternoon searching for.
          </p>

          <p>
            He also possesses what has been described as an “almost supernatural
            tolerance for noise.”
          </p>

          <p>
            James allegedly slept through a thunderstorm, a smoke detector, a lawn
            mower, and a television playing at a volume that caused a neighbor to
            complain.
          </p>

          <p>He woke up when someone quietly opened a refrigerator.</p>

          <p>
            His vocal talents are similarly difficult to quantify.
          </p>

          <p>
            James has been known to contribute harmonies that begin several milliseconds
            before everyone else's, creating what musicologists have tentatively
            classified as “pre-harmony.”
          </p>

          <p>He denies doing this intentionally.</p>
        </article>

        <article class="band-member">
          <h2>John “Fart” Edwards</h2>
          <p><strong>Guitar • Vocals • Unlicensed Guitar Technology • Cultural Disruptor</strong></p>

          <p>
            John “Fart” Edwards is the most difficult member of the Chad Edwards Band
            to describe accurately.
          </p>

          <p>
            Part of the problem is that nobody agrees where his nickname came from.
          </p>

          <p>
            The other problem is that nobody agrees where his guitar playing came from.
          </p>

          <p>
            John is said to have spent years developing an unconventional approach to
            guitar that combines traditional country picking, rock sensibilities,
            blues phrasing, and an instinctive refusal to leave a song alone when it
            could contain another guitar part.
          </p>

          <p>
            His playing has occasionally been described as “technically unnecessary
            but spiritually essential.”
          </p>

          <h3>The Guitar</h3>

          <p>
            John allegedly owns or has owned a number of guitars with histories that
            would be considered implausible if they were written down.
          </p>

          <p>
            One instrument is rumored to have been purchased from a musician who claimed
            it had previously belonged to a touring act whose name John refuses to
            reveal.
          </p>

          <p>
            Another supposedly spent several years in the back of a vehicle before
            becoming John's primary instrument.
          </p>

          <p>
            A third is said to have been repaired using a technique John invented
            himself after watching someone fix a lawn chair.
          </p>

          <p>
            John has also allegedly developed a proprietary guitar setup method that
            involves measurements no recognized guitar technician uses.
          </p>

          <p>It works anyway.</p>

          <h3>The Solo</h3>

          <p>
            John is believed to hold the unofficial record for extending a guitar solo
            beyond the point where the rest of the band had stopped expecting one.
          </p>

          <p>
            According to one account, the original solo lasted approximately 32 seconds.
          </p>

          <p>John continued.</p>

          <p>The band eventually began the next song.</p>

          <p>John continued.</p>

          <p>Eventually the audience applauded.</p>

          <p>Nobody knows whether this was encouragement or relief.</p>

          <h3>Life Beyond Music</h3>

          <p>
            John's non-musical accomplishments are similarly difficult to verify.
          </p>

          <p>
            He reportedly once identified a vehicle's mechanical problem entirely by
            listening to it from approximately 100 feet away.
          </p>

          <p>He has allegedly won at least one argument with a GPS.</p>

          <p>He can reportedly identify several varieties of lumber by smell.</p>

          <p>
            He once spent an entire afternoon attempting to determine why a particular
            door would not close properly and ultimately discovered that the door was
            supposed to remain open.
          </p>

          <p>He considered the experiment successful.</p>

          <p>
            John is also rumored to possess an exceptional ability to locate live music
            in unfamiliar towns.
          </p>

          <p>His method has never been disclosed.</p>

          <p>When asked how he does it, he reportedly responds:</p>

          <blockquote>
            <p>“You just know.”</p>
          </blockquote>

          <h3>The Name</h3>

          <p>
            The nickname “Fart” remains perhaps John's greatest accomplishment.
          </p>

          <p>
            Despite decades of inquiry, no definitive origin story has emerged.
          </p>

          <p>At least six competing explanations circulate.</p>

          <ul>
            <li>One involves a campfire.</li>
            <li>One involves a school bus.</li>
            <li>One involves a guitar case.</li>
            <li>One involves a county fair.</li>
            <li>One involves an event that John insists never happened.</li>
            <li>
              And one explanation is so elaborate that, if true, it would make John
              simultaneously the victim, perpetrator, witness, and eventual beneficiary
              of an extremely unusual chain of events.
            </li>
          </ul>

          <p>John has declined to clarify.</p>

          <p>This has only increased speculation.</p>
        </article>

        <section class="band-legacy">
          <h2>The Edwards Legacy</h2>

          <p>
            Taken individually, the four members of the Chad Edwards Band possess an
            improbable collection of talents.
          </p>

          <p>
            Taken together, they represent something much stranger.
          </p>

          <p>The Edwards family is rumored to have produced:</p>

          <ul>
            <li>At least one exceptional cook</li>
            <li>At least one suspiciously competent mechanic</li>
            <li>Several people who can identify songs from extremely little information</li>
            <li>An unknown number of amateur historians</li>
            <li>A disproportionately high number of people who believe they can fix things</li>
            <li>One person who reportedly knows how to get almost anywhere without GPS</li>
            <li>And four musicians who somehow ended up in the same band</li>
          </ul>

          <p>
            There are persistent rumors that the family has been involved in music for
            generations.
          </p>

          <p>There are also rumors that this is completely untrue.</p>

          <p>
            Both stories have been repeated so often that nobody can remember which one
            was invented first.
          </p>

          <p>
            What <em>is</em> known is that when Chad, Mikey, James, and John take the
            stage, something happens that cannot be fully explained by conventional
            music theory.
          </p>

          <p>The guitars get louder.</p>
          <p>The bass gets deeper.</p>
          <p>The drums get less reasonable.</p>

          <p>And, sooner or later, somebody says:</p>

          <blockquote>
            <p><strong>“Who the hell are these Edwards guys?”</strong></p>
          </blockquote>

          <p>The answer, increasingly, is:</p>

          <p><strong>Nobody really knows.</strong></p>

          <p>And that's exactly how they like it.</p>
        </section>
      </section>
    </div>
  </div>
};

export default About;